import { Map } from 'immutable';

/**
 *
 * Get the event room ID
 *
 * @param {any} teamId
 * @param {any} event
 */
export function getEventRoomId(teamId, event) {
  const eventId = Map.isMap(event) ? event.get('_id') : event;

  let resolvedTeamId = teamId;
  //If the team ID context is not set, try to get it from the event...
  if (!resolvedTeamId && Map.isMap(event)) {
    resolvedTeamId = event.get('team');
    if (Map.isMap(resolvedTeamId)) {
      resolvedTeamId = resolvedTeamId.get('_id');
    }
  }

  return `event.${eventId}`;
}
